<template>
  <div>
    <CCard>
      <DatePicker
        v-model="value1"
        type="date"
        range
        placeholder="Select date range"
        style="float: left"
      ></DatePicker>
      <CCardBody>
        <CDataTable
          :items="tableData"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
          responsive
        >
          <template #icon="{ item }">
            <td>
              <img :Src="item.icon" class="icon" />
            </td>
          </template>
          <template #matchStatus="{ item }">
            <td>
              <span v-if="item.matchStatus == 'Live'">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-success ml-1"
                >
                  Live
                </a></span
              >
              <span v-if="item.matchStatus == 'Completed'">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-warning ml-1"
                >
                  Completed
                </a></span
              >
              <span v-if="item.matchStatus == 'Cancelled'">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-danger ml-1"
                >
                  Cancelled
                </a></span
              >
              <span v-if="item.matchStatus == 'Upcoming'">
                <a
                  href="#"
                  rel="noreferrer noopener"
                  target="_blank"
                  class="badge badge-info ml-1"
                >
                  Upcoming
                </a></span
              >
            </td>
          </template>
          <template #winners="{ item }">
            <td>
              <JsonCSV
                v-if="item.winners.length != 0"
                color="success"
                class="btn btn-default mb-2 clr"
                :data="item.winners"
                name="Tournaments_winners.csv"
                style="background: aquamarine"
              >
                Download
              </JsonCSV>
            </td>
          </template>
          <template #isUser="{ item }">
            <td>
              <CButton
                color="primary"
                style="width: -webkit-fill-available; margin-left: 10px"
                v-if="item.isUser == false"
                >Admin</CButton
              >

              <CButton
                v-if="item.isUser == true"
                color="warning"
                class="ml-2"
                style="width: -webkit-fill-available; margin-left: 10px"
                >User</CButton
              >
            </td>
          </template>

          <template #View="{ item }">
            <td>
              <CButton
                color="primary"
                style="width: -webkit-fill-available; margin-left: 10px"
                @click="filterdata(item.id)"
                >Players</CButton
              >
              <br /><br />
              <CButton
                v-if="
                  item.matchStatus == 'Upcoming' || item.matchStatus == 'Live'
                "
                color="success"
                class="ml-2"
                style="width: -webkit-fill-available; margin-left: 10px"
                @click="editTournament(item)"
                >Edit</CButton
              >
              <br /><br />
              <CButton
                v-if="user.userRole == 'user'"
                color="success"
                class="ml-2"
                style="width: -webkit-fill-available; margin-left: 10px"
                @click="viewLeaderBoard(item)"
                >View LeaderBoard</CButton
              >
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import firebase from "firebase";
const db = firebase.firestore();
import moment from "moment";
import Swal from "sweetalert2";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { APIService } from "../../apiservice";
export default {
  components: {
    JsonCSV,
    DatePicker,
  },
  data() {
    return {
      value1: [],
      tableData: [],
      fields: [
        {
          label: "created",
          key: "created",
          sortable: true,
        },
        {
          label: "Icon",
          key: "icon",
          sortable: true,
        },
        {
          label: "Name",
          key: "name",
          sortable: true,
        },
        {
          label: "Match Status",
          key: "matchStatus",
          sortable: true,
        },
        {
          label: "Tournament ID",
          key: "tournamentId",
          sortable: true,
        },
        {
          label: "Participants",
          key: "participants",
          sortable: true,
        },
        {
          label: "Created By",
          key: "isUser",
          sortable: true,
        },
        {
          label: "Action",
          key: "winners",
          sortable: true,
        },
        {
          label: "View",
          key: "View",
          sortable: true,
        },
      ],
    };
  },
  watch: {
    value1() {
      try {
        console.log("enetered", this.value1);
        var res = new Date(this.value1[1]);
        res.setDate(res.getDate() + 1);
        this.tableData = [];
        let v1 = firebase.firestore.Timestamp.fromDate(
          new Date(this.value1[0])
        );
        let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));
        db.collection("tournamentGames")
          .where("isContestEnabled", "==", true)
          .where("created", ">", v1)
          .where("created", "<", v2)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              this.tableData.push({
                id: doc.id,
                name: doc.data().gameName,
                icon: doc.data().gameImage,
                matchStatus: doc.data().matchStatus,
                tournamentId: doc.data().tournamentId,
                winners: doc.data().winnersList ? doc.data().winnersList : [],
                isUser: doc.data().isUser ? doc.data().isUser : false,
                participants: doc.data().participants,
                created: moment(doc.data().created.seconds * 1000).format(
                  "DD-MMM-YYYY, hh:mm a"
                ),
              });
            });
            console.log(" this.tableData", this.tableData);
          })
          .catch((e) => {
            console.log("Erorr: ", e.message);
          });
      } catch (error) {
        console.log("Erorr: ", error);
        console.log("Erorr: ", error.message);
      }
    },
  },
  methods: {
    filterdata(DocId) {
      this.$router.push({ name: "tournamentPractice", params: { id: DocId } });
    },
    showMessage(msg, icon) {
      Swal.fire({
        position: "center",
        icon: icon,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    viewLeaderBoard(item) {
      this.$router.push({
        name: "tournamentLeaderboard",
        params: {
          id: item.tournamentId,
        },
      });
    },
    async editTournament(item) {
      // console.log("items", item);
      let nameRoute = item.isFree ? "editFreeTournament" : "editTournamentV2";
      if (this.user.userRole == "user") {
        let isTournEdit = await APIService.isTournamentEdit(item.id);

        console.log("responde", isTournEdit);
        if (!isTournEdit.isAllow) {
          this.showMessage(isTournEdit.Message, "error");
        } else {
          this.$router.push({
            name: nameRoute,
            params: {
              id: item.id,
            },
          });
        }
      } else {
        this.$router.push({
          name: nameRoute,
          params: {
            id: item.id,
          },
        });
      }
    },
    getGamesForUser() {
      console.log("userss");
      var res = new Date();
      res.setDate(res.getDate() - 2);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date());
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));

      db.collection("tournamentGames")
        // .where("isContestEnabled", "==", true)
        .where("uId", "==", this.user.uid)
        .where("created", ">=", v2)
        .where("created", "<=", v1)
        .get()
        .then((snapshot) => {
          this.tableData = [];
          var i = 0;
          var dateNow = new Date();
          snapshot.forEach((doc) => {
            this.tableData.push({
              id: doc.id,
              name: doc.data().gameName,
              icon: doc.data().gameImage,
              matchStatus: doc.data().matchStatus,
              tournamentId: doc.data().tournamentId,
              participants: doc.data().participants,
              winners: doc.data().winnersList ? doc.data().winnersList : [],
              isFree: doc.data().isFree,
              isUser: doc.data().isUser ? doc.data().isUser : false,
              created: moment(doc.data().created.seconds * 1000).format(
                "DD-MMM-YYYY, hh:mm a"
              ),
            });
          });
        })
        .catch((e) => {
          console.log("Erorr: ", e.message);
        });
    },
    getGames() {
      var res = new Date();
      res.setDate(res.getDate() - 2);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date());
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));

      db.collection("tournamentGames")
        .where("isContestEnabled", "==", true)
        .where("created", ">=", v2)
        .where("created", "<=", v1)
        .get()
        .then((snapshot) => {
          this.tableData = [];
          var i = 0;
          var dateNow = new Date();
          snapshot.forEach((doc) => {
            this.tableData.push({
              id: doc.id,
              name: doc.data().gameName,
              icon: doc.data().gameImage,
              matchStatus: doc.data().matchStatus,
              tournamentId: doc.data().tournamentId,
              participants: doc.data().participants,
              winners: doc.data().winnersList ? doc.data().winnersList : [],
              isFree: doc.data().isFree,
              isUser: doc.data().isUser ? doc.data().isUser : false,
              created: moment(doc.data().created.seconds * 1000).format(
                "DD-MMM-YYYY, hh:mm a"
              ),
            });
          });
        })
        .catch((e) => {
          console.log("Erorr: ", e.message);
        });
    },
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("data"));
    // console.log("is checkckckc", this.user);
    if (this.user.userRole == "user") {
      this.getGamesForUser();
    } else {
      this.getGames();
    }
  },
};
</script>